import { render, staticRenderFns } from "./temporaryHomeworkReporting.vue?vue&type=template&id=4ecb27f8&scoped=true&"
import script from "./temporaryHomeworkReporting.vue?vue&type=script&lang=ts&"
export * from "./temporaryHomeworkReporting.vue?vue&type=script&lang=ts&"
import style0 from "./temporaryHomeworkReporting.vue?vue&type=style&index=0&id=4ecb27f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb27f8",
  null
  
)

export default component.exports